export default "__VITE_ASSET__Dd009ZR4__"